import { Component, OnInit } from '@angular/core'
import { ClinicService, DEFAULT_TIMEZONE, EstimateService, getLogTypeName, getTimeZone } from '@mmx/shared'

@Component({
  selector: 'mmx-estimate-history-dialog',
  templateUrl: './estimate-history-dialog.component.html',
  standalone: false,
})
export class EstimateHistoryDialogComponent implements OnInit {
  public tz = DEFAULT_TIMEZONE
  public getLogTypeName = getLogTypeName

  constructor(
    public estimateService: EstimateService,
    private clinicService: ClinicService,
  ) { }

  public ngOnInit() {
    this.tz = getTimeZone(this.clinicService.clinic)
  }
}
